'use client';

import  './Breadcrumb.scss';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function Breadcrumb() {
  const pathname = usePathname(); // e.g. "/used/cars/toyota-corolla"
  const rawSegments = pathname.split('/').filter(Boolean); // ['used', 'cars', 'toyota-corolla']
  const breadcrumbs: { label: string; href: string }[] = [];

  // Custom logic: combine 'used/cars' into a single breadcrumb
  if (rawSegments[0] === 'used' && rawSegments[1] === 'cars') {
    breadcrumbs.push({
      label: 'Used Cars',
      href: '/used/cars',
    });

    // Add the rest of the segments after 'used/cars'
    for (let i = 2; i < rawSegments.length; i++) {
      breadcrumbs.push({
        label: decodeURIComponent(rawSegments[i]).replace(/-/g, ' '),
        href: '/' + rawSegments.slice(0, i + 1).join('/'),
      });
    }
  } else {
    // Default behavior: map all segments
    rawSegments.forEach((segment, index) => {
      breadcrumbs.push({
        label: decodeURIComponent(segment).replace(/-/g, ' '),
        href: '/' + rawSegments.slice(0, index + 1).join('/'),
      });
    });
  }

  return (
    <div className="l-breadcrumb__outer">
        <div className="l-breadcrumb">
            <div className="l-breadcrumb__inner">
                <ul className="breadcrumb">
                    <li>
                    <Link href="/">Home</Link>
                    </li>

                    {breadcrumbs.map((crumb, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    return (
                        <li key={crumb.href}>
                        {!isLast ? (
                            <>
                            <Link href={crumb.href}>{crumb.label}</Link>
                            </>
                        ) : (
                            <span>{crumb.label}</span>
                        )}
                        </li>
                    );
                    })}
                </ul>
            </div>
        </div>
    </div>
  );
}
